import { remoteCustomFetcher } from '@/providers/backendClient';
import { CustomPipelineFactory } from '@/providers/dataProvider';

export const therapistsCustomFetcher: CustomPipelineFactory = async ({
  sort,
  filter,
  page,
  perPage,
  signal,
}) => {
  const result = await remoteCustomFetcher('therapists', {
    sort,
    filter,
    page,
    perPage,
    signal,
  });

  return result;

  // const deletedAtMatch = (() => {
  //   if (deletedAt === "hidden") {
  //     return { deletedAt: null };
  //   }

  //   // if (deletedAt === "only") {
  //   //   return {};
  //   // }

  //   return {};
  // })();

  // const calendarIntegrationMatch = (() => {
  //   if (calendarIntegration === "connected") {
  //     return { "calendarIntegration.resourceId": { $ne: null } };
  //   }

  //   if (calendarIntegration === "disconnected") {
  //     return { "calendarIntegration.resourceId": null };
  //   }

  //   return {};
  // })();

  // const notificationsEnabledMatch = (() => {
  //   if (notificationsEnabled === "connected") {
  //     return { notificationsEnabled: true };
  //   }

  //   if (notificationsEnabled === "disabled") {
  //     return { notificationsEnabled: { $ne: true } };
  //   }

  //   return {};
  // })();

  // console.log("deletedAtMatch", deletedAtMatch);

  // const signupCompletedAtMatch = (() => {
  //   if (signupCompletedAt === "hidden") {
  //     return { signupCompletedAt: { $ne: null } };
  //   }

  //   if (signupCompletedAt === "only") {
  //     return { signupCompletedAt: null };
  //   }

  //   return {};
  // })();

  // console.log("signupCompletedAtMatch", signupCompletedAtMatch);

  // const isHiddenTestAccountMatch = (() => {
  //   if (isHiddenTestAccount === "hidden") {
  //     return { isHiddenTestAccount: { $ne: true } };
  //   }

  //   if (isHiddenTestAccount === "only") {
  //     return { isHiddenTestAccount: true };
  //   }

  //   return {};
  // })();

  // const hasNameMatch = !!firstName || !!lastName;

  // const namesMatch = hasNameMatch
  //   ? {
  //       $match: {
  //         ...(firstName ? { firstName } : {}),
  //         ...(lastName ? { lastName } : {}),
  //       },
  //     }
  //   : {};

  // // const namesMatch = (() => {
  // //   if (!firstName && !lastName) {
  // //     return {};
  // //   }

  // //   const firstNameMatch = firstName
  // //     ? firstName
  // //     : { $in: [firstName, `${firstName} `] };

  // //   const lastNameMatch = lastName
  // //     ? lastName
  // //     : { $in: [lastName, `${lastName} `] };

  // //   return {
  // //     ...firstNameMatch,
  // //     ...lastNameMatch,
  // //   };
  // // })();

  // const combinedFilter = {
  //   ...calendarIntegrationMatch,
  //   ...filter,
  //   ...deletedAtMatch,
  //   ...signupCompletedAtMatch,
  //   ...isHiddenTestAccountMatch,
  //   ...notificationsEnabledMatch,
  // };

  // const hasExtraneousMatch = !!accountInfo$status || !!accountInfo$isActive;

  // const extraneousFilteringPipeline = hasExtraneousMatch
  //   ? [
  //       createFilteringStage({
  //         ...(accountInfo$status ? { accountInfo$status } : {}),
  //         ...(accountInfo$isActive ? { accountInfo$isActive } : {}),
  //       }),
  //     ]
  //   : [];

  // console.log("combinedFilter", combinedFilter);

  // const match = createFilteringStage(combinedFilter);

  // console.log("match", match);

  // const sortStage =
  //   sort.field !== "sessionNotes.last.createdAt" ? createSortStage(sort) : null;

  // const pagingPipeline = createPagingStages(page, perPage);

  // const nameTrimmingStage = hasNameMatch ? [trimNamesStage] : [];

  // const primarySortPagingStages = sortStage
  //   ? [sortStage, ...pagingPipeline]
  //   : [];

  // const lastSessionNoteSortStages =
  //   sort.field === "sessionNotes.last.createdAt"
  //     ? [
  //         {
  //           $sort: {
  //             "sessionNotes.last.createdAt": sort.order === "ASC" ? 1 : -1,
  //           },
  //         },
  //         ...pagingPipeline,
  //       ]
  //     : [];

  // console.log("extraneousFilteringStage", extraneousFilteringPipeline);

  // const resultsPipeline = [
  //   match,
  //   // ...nameTrimmingStage,
  //   ...(hasNameMatch ? [namesMatch] : []),
  //   ...(hasExtraneousMatch ? [...accountStatusPipeline()] : []),
  //   ...(hasExtraneousMatch ? [...extraneousFilteringPipeline] : []),
  //   ...primarySortPagingStages,
  //   ...(!hasExtraneousMatch ? [...accountStatusPipeline()] : []),
  //   ...reportPipeline(lastSessionNoteSortStages),
  // ];

  // console.log("resultsPipeline", resultsPipeline);

  // const countPipeline = createCountPipeline([
  //   match,
  //   ...(hasExtraneousMatch
  //     ? [...accountStatusPipeline(), ...extraneousFilteringPipeline]
  //     : []),
  // ]);

  // const pipelines = {
  //   results: resultsPipeline,
  //   total: countPipeline,
  // };

  // const { results, total: [{ count = 0 } = {}] = [] } = await aggregate(
  //   "therapists",
  //   pipelines,
  //   {
  //     allowDiskUse: true,
  //   }
  // );

  // return { results, total: count };
};

const trimNamesStage = {
  $addFields: {
    firstName: {
      $trim: {
        input: '$firstName',
      },
    },
    lastName: {
      $trim: {
        input: '$lastName',
      },
    },
  },
};

// const lastSessionNoteSortStages = sort.field === "sessionNotes.last.createdAt" ? [

export const accountStatusPipeline = () => [
  {
    $addFields: {
      freeTrial: {
        count: {
          $ifNull: ['$freeTrialNotesCount', 0],
        },
        balance: {
          $subtract: [
            {
              $ifNull: ['$freeTrialNotesCount', 0],
            },
            {
              $size: {
                $ifNull: ['$freeTrialNotesHistory', []],
              },
            },
          ],
        },
        history: '$freeTrialNotesHistory',
        usage: {
          $size: {
            $ifNull: ['$freeTrialNotesHistory', []],
          },
        },
      },
    },
  },
  {
    $project: {
      freeTrialNotesHistory: 0,
      freeTrialNotesCount: 0,
    },
  },
  {
    $addFields: {
      accountInfo: {
        isTrialing: {
          $and: [
            {
              $not: '$subscriptionExpirationDate',
            },
            {
              $or: [
                {
                  $gt: ['$freeTrial.balance', 0],
                },
                {
                  $not: '$freeTrial.count',
                },
              ],
            },
          ],
        },
        isSubscriptionActive: {
          $ifNull: [
            '$billing.currentSubscription.gives_access',
            false,
          ],
        },
        isCustomer: {
          $eq: [
            {
              $ifNull: [
                '$billing.currentSubscription.gives_access',
                false,
              ],
            },
            true,
          ],
        },
        hasBillingIssues: {
          $in: [
            '$billing.currentSubscription.status',
            ['in_grace_period', 'in_billing_retry'],
          ],
        },
        isCancelled: {
          $in: ['$billing.currentSubscription.status', ['expired']],
        },
      },
    },
  },
  {
    $addFields: {
      'accountInfo.isReactivated': {
        $and: [
          '$accountInfo.isSubscriptionActive',
          {
            $gt: [
              {
                $size: {
                  $ifNull: ['$billing.subscriptions', []],
                },
              },
              0,
            ],
          },
        ],
      },
      'accountInfo.isLifelongTrial': {
        $and: [
          {
            $not: '$freeTrial.count',
          },
          {
            $not: '$accountInfo.isCustomer',
          },
        ],
      },
      'accountInfo.isPendingCancellation': {
        $and: [
          '$accountInfo.isCustomer',
          {
            $in: [
              '$billing.currentSubscription.auto_renewal_status',
              ['will_not_renew'],
            ],
          },
        ],
      },
      'accountInfo.freeSubscriptionExpirationDate': {
        $cond: {
          if: {
            $not: '$accountInfo.isSubscriptionActive',
          },
          then: {
            $ifNull: ['$subscriptionExpirationDate', null],
          },
          else: null,
        },
      },
    },
  },
  {
    $addFields: {
      'accountInfo.trialStatus': {
        $cond: {
          if: '$accountInfo.isLifelongTrial',
          then: 'lifelong',
          else: {
            $cond: {
              if: '$accountInfo.isTrialing',
              then: 'ongoing',
              else: {
                $cond: {
                  if: {
                    $lte: ['$freeTrial.balance', 0],
                  },
                  then: 'completed',
                  else: 'bypassed',
                },
              },
            },
          },
        },
      },
      'billing.firstSubscription': {
        $cond: {
          if: {
            $eq: ['$accountInfo.isReactivated', true],
          },
          then: {
            $last: '$billing.subscriptions',
          },
          else: '$billing.currentSubscription',
        },
      },
      'accountInfo.hasFreeSubscription': {
        $not: {
          $not: '$accountInfo.freeSubscriptionExpirationDate',
        },
      },
      'accountInfo.freeSubscriptionExpired': {
        $cond: {
          if: '$accountInfo.freeSubscriptionExpirationDate',
          then: {
            $lte: [
              '$accountInfo.freeSubscriptionExpirationDate',
              '$$NOW',
            ],
          },
          else: null,
        },
      },
    },
  },
  {
    $addFields: {
      'accountInfo.firstSubscribedAt': {
        $toDate:
          '$billing.firstSubscription.current_period_starts_at',
      },
      'accountInfo.isActive': {
        $or: [
          '$accountInfo.isLifelongTrial',
          '$accountInfo.isTrialing',
          '$accountInfo.isSubscriptionActive',
          {
            $and: [
              '$accountInfo.freeSubscriptionExpirationDate',
              {
                $not: '$accountInfo.freeSubscriptionExpired',
              },
            ],
          },
        ],
      },
    },
  },
  {
    $addFields: {
      'accountInfo.status': {
        $switch: {
          branches: [
            {
              case: {
                $eq: ['$accountInfo.trialStatus', 'ongoing'],
              },
              then: 'trialing',
            },
            {
              case: {
                $eq: ['$accountInfo.trialStatus', 'lifelong'],
              },
              then: 'lifelong-trial',
            },
            {
              case: {
                $and: [
                  '$accountInfo.freeSubscriptionExpirationDate',
                  {
                    $not: '$accountInfo.freeSubscriptionExpired',
                  },
                ],
              },
              then: 'free-subscription',
            },
            {
              case: '$accountInfo.isPendingCancellation',
              then: 'pending-cancellation',
            },
            {
              case: '$accountInfo.hasBillingIssues',
              then: 'billing-issues',
            },
            {
              case: '$accountInfo.isCancelled',
              then: 'cancelled',
            },
            {
              case: '$accountInfo.isReactivated',
              then: 'reactivated',
            },
            {
              case: '$accountInfo.isSubscriptionActive',
              then: 'customer',
            },
            {
              case: {
                $eq: ['$accountInfo.trialStatus', 'completed'],
              },
              then: 'trial-completed',
            },
          ],
          default: 'unknown',
        },
      },
    },
  },
];

export const reportPipeline = (lastSessionNoteSortStages: any[]) => [
  {
    $lookup: {
      from: 'therapistSessionNotes_deleted',
      let: {
        therapistId: '$_id',
      },
      pipeline: [
        {
          $match: {
            $expr: {
              $eq: ['$therapistId', '$$therapistId'],
            },
          },
        },
        {
          $addFields: {
            transcript: {
              $binarySize: '$transcript',
            },
            narrative: {
              $binarySize: '$narrative',
            },
            title: {
              $binarySize: '$title',
            },
            grammar: {
              $binarySize: '$grammar',
            },
            singleSentence: {
              $binarySize: '$singleSentence',
            },
            tags: {
              $binarySize: '$tags',
            },
            bullet: {
              $binarySize: '$bullet',
            },
          },
        },
        {
          $sort: {
            _id: -1,
          },
        },
      ],
      as: 'sessionNotes_deleted',
    },
  },
  {
    $addFields: {
      deletedSessionNotesData: {
        live: {
          $filter: {
            input: '$sessionNotes_deleted',
            cond: '$$this.live',
          },
        },
        sample: {
          $filter: {
            input: '$sessionNotes_deleted',
            cond: '$$this.isSampleNote',
          },
        },
        committed: {
          $filter: {
            input: '$sessionNotes_deleted',
            cond: {
              $ne: ['$$this.status', 'draft'],
            },
          },
        },
        dictation: {
          $filter: {
            input: '$sessionNotes_deleted',
            cond: {
              $not: '$$this.live',
            },
          },
        },
        all: '$sessionNotes_deleted',
        last: {
          $first: '$sessionNotes_deleted',
        },
        total: {
          $size: '$sessionNotes_deleted',
        },
      },
      sessionNotes_deleted: null,
    },
  },
  {
    $lookup: {
      from: 'therapistSessionNotes',
      let: {
        therapistId: '$_id',
      },
      pipeline: [
        {
          $match: {
            $expr: {
              $eq: ['$therapistId', '$$therapistId'],
            },
          },
        },
        {
          $addFields: {
            transcript: {
              $binarySize: '$transcript',
            },
            narrative: {
              $binarySize: '$narrative',
            },
            title: {
              $binarySize: '$title',
            },
            grammar: {
              $binarySize: '$grammar',
            },
            singleSentence: {
              $binarySize: '$singleSentence',
            },
            tags: {
              $binarySize: '$tags',
            },
            bullet: {
              $binarySize: '$bullet',
            },
          },
        },
        {
          $sort: {
            _id: -1,
          },
        },
      ],
      as: 'sessionNotes',
    },
  },
  {
    $addFields: {
      sessionNotesData: {
        live: {
          $filter: {
            input: '$sessionNotes',
            cond: '$$this.live',
          },
        },
        sample: {
          $filter: {
            input: '$sessionNotes',
            cond: '$$this.isSampleNote',
          },
        },
        committed: {
          $filter: {
            input: '$sessionNotes',
            cond: {
              $ne: ['$$this.status', 'draft'],
            },
          },
        },
        dictation: {
          $filter: {
            input: '$sessionNotes',
            cond: {
              $not: '$$this.live',
            },
          },
        },
        all: '$sessionNotes',
        last: {
          $first: '$sessionNotes',
        },
        total: {
          $size: '$sessionNotes',
        },
      },
      sessionNotes: null,
    },
  },
  {
    $addFields: {
      dictationData: {
        active: '$sessionNotesData.dictation',
        deleted: '$deletedSessionNotesData.dictation',
        last: {
          $first: '$sessionNotesData.dictation',
        },
        total: {
          $sum: [
            {
              $size: '$sessionNotesData.dictation',
            },
            {
              $size: '$deletedSessionNotesData.dictation',
            },
          ],
        },
      },
    },
  },
  {
    $addFields: {
      liveData: {
        active: '$sessionNotesData.live',
        deleted: '$deletedSessionNotesData.live',
        last: {
          $first: '$sessionNotesData.live',
        },
        total: {
          $sum: [
            {
              $size: '$sessionNotesData.live',
            },
            {
              $size: '$deletedSessionNotesData.live',
            },
          ],
        },
      },
    },
  },
  {
    $addFields: {
      sessionNotes: {
        live: {
          active: {
            data: '$liveData.active',
            last: {
              $first: '$liveData.active',
            },
            count: {
              $size: '$liveData.active',
            },
          },
          deleted: {
            data: '$liveData.deleted',
            last: {
              $first: '$liveData.deleted',
            },
            count: {
              $size: '$liveData.deleted',
            },
          },
          last: '$liveData.last',
          total: '$liveData.total',
        },
        dictation: {
          active: {
            data: '$dictationData.active',
            last: {
              $first: '$dictationData.active',
            },
            count: {
              $size: '$dictationData.active',
            },
          },
          deleted: {
            data: '$dictationData.deleted',
            last: {
              $first: '$dictationData.deleted',
            },
            count: {
              $size: '$dictationData.deleted',
            },
          },
          last: '$dictationData.last',
          total: '$dictationData.total',
        },
        active: {
          data: '$sessionNotesData.all',
          last: {
            $first: '$sessionNotesData.all',
          },
          count: {
            $size: '$sessionNotesData.all',
          },
        },
        sample: {
          data: {
            $sortArray: {
              input: {
                $concatArrays: [
                  '$sessionNotesData.sample',
                  '$deletedSessionNotesData.sample',
                ],
              },
              sortBy: {
                _id: -1,
              },
            },
          },
        },
        committed: {
          data: {
            $sortArray: {
              input: {
                $concatArrays: [
                  '$sessionNotesData.committed',
                  '$deletedSessionNotesData.committed',
                ],
              },
              sortBy: {
                _id: -1,
              },
            },
          },
        },
        deleted: {
          data: '$deletedSessionNotesData',
          last: {
            $first: '$deletedSessionNotesData.all',
          },
          committed: {
            $filter: {
              input: '$deletedSessionNotesData.all',
              cond: {
                $ne: ['$$this.status', 'draft'],
              },
            },
          },
          sample: {
            $filter: {
              input: '$deletedSessionNotesData.all',
              cond: '$$this.isSampleNote',
            },
          },
          count: {
            $size: '$deletedSessionNotesData.all',
          },
        },
        last: '$sessionNotesData.last',
        total: {
          $sum: [
            '$sessionNotesData.total',
            '$deletedSessionNotesData.total',
          ],
        },
      },
      liveData: null,
      dictationData: null,
      sessionNotesData: null,
    },
  },
  {
    $addFields: {
      'sessionNotes.committed.last': {
        $first: '$sessionNotes.committed.data',
      },
      'sessionNotes.committed.count': {
        $size: '$sessionNotes.committed.data',
      },
      'sessionNotes.sample.last': {
        $first: '$sessionNotes.sample.data',
      },
      'sessionNotes.sample.count': {
        $size: '$sessionNotes.sample.data',
      },
    },
  },
  {
    $project: {
      liveData: 0,
      dictationData: 0,
      sessionNotesData: 0,
      deletedSessionNotesData: 0,
      'sessionNotes.committed.data': 0,
      'sessionNotes.sample.data': 0,
      'sessionNotes.live.active.data': 0,
      'sessionNotes.live.deleted.data': 0,
      'sessionNotes.dictation.active.data': 0,
      'sessionNotes.deleted.data': 0,
      'sessionNotes.deleted.committed': 0,
      'sessionNotes.active.data': 0,
    },
  },
  ...lastSessionNoteSortStages,
  {
    $lookup: {
      from: 'therapistHomework',
      let: {
        therapistId: '$_id',
      },
      pipeline: [
        {
          $match: {
            $expr: {
              $eq: ['$therapistId', '$$therapistId'],
            },
          },
        },
        {
          $addFields: {
            transcript: {
              $binarySize: '$transcript',
            },
            narrative: {
              $binarySize: '$narrative',
            },
            followUpQuestion: {
              $binarySize: '$followUpQuestion',
            },
          },
        },
        {
          $sort: {
            _id: -1,
          },
        },
      ],
      as: 'homework',
    },
  },
  {
    $addFields: {
      homeworkData: {
        active: {
          $filter: {
            input: '$homework',
            cond: {
              $not: '$$this.deletedAt',
            },
          },
        },
        shared: {
          $filter: {
            input: '$homework',
            cond: '$$this.homeworkSharedAt',
          },
        },
        deleted: {
          $filter: {
            input: '$homework',
            cond: '$$this.deletedAt',
          },
        },
        last: {
          $first: '$homework',
        },
        total: {
          $size: '$homework',
        },
      },
      homework: null,
    },
  },
  {
    $addFields: {
      homework: {
        active: {
          data: '$homeworkData.active',
          last: {
            $first: '$homeworkData.active',
          },
          count: {
            $size: '$homeworkData.active',
          },
        },
        shared: {
          data: '$homeworkData.shared',
          last: {
            $first: '$homeworkData.shared',
          },
          count: {
            $size: '$homeworkData.shared',
          },
        },
        deleted: {
          data: '$homeworkData.deleted',
          last: {
            $first: '$homeworkData.deleted',
          },
          count: {
            $size: '$homeworkData.deleted',
          },
        },
        last: '$homeworkData.last',
        total: '$homeworkData.total',
      },
      homeworkData: null,
    },
  },
  {
    $project: {
      homeworkData: 0,
      'homework.active.data': 0,
      'homework.shared.data': 0,
      'homework.deleted.data': 0,
    },
  },
  {
    $lookup: {
      from: 'therapistPatients',
      let: {
        therapistId: '$_id',
      },
      pipeline: [
        {
          $match: {
            $expr: {
              $and: [
                {
                  $eq: ['$therapistId', '$$therapistId'],
                },
              ],
            },
          },
        },
        {
          $addFields: {
            patientPublicKey: {
              $binarySize: '$patientPublicKey',
            },
            patientFirstName: {
              $binarySize: '$patientFirstName',
            },
            patientLastInitial: {
              $binarySize: '$patientLastInitial',
            },
          },
        },
        {
          $project: {
            therapistEmail: 0,
            therapistFirstName: 0,
            therapistLastName: 0,
            therapistPhoneNumber: 0,
            therapistPublicKey: 0,
            therapistTitle: 0,
          },
        },
        {
          $sort: {
            _id: -1,
          },
        },
      ],
      as: 'patients',
    },
  },
  {
    $addFields: {
      patientsData: {
        active: {
          $filter: {
            input: '$patients',
            cond: {
              $not: '$$this.deletedAt',
            },
          },
        },
        deleted: {
          $filter: {
            input: '$patients',
            cond: '$$this.deletedAt',
          },
        },
        archived: {
          $filter: {
            input: '$patients',
            cond: '$$this.archivedAt',
          },
        },
        connected: {
          $filter: {
            input: '$patients',
            cond: {
              $and: [
                {
                  $not: '$$this.deletedAt',
                },
                '$$this.patientConnectedAt',
              ],
            },
          },
        },
        disconnected: {
          $filter: {
            input: '$patients',
            cond: {
              $and: [
                {
                  $not: '$$this.deletedAt',
                },
                '$$this.patientDisconnectedAt',
              ],
            },
          },
        },
        last: {
          $first: '$patients',
        },
        total: {
          $size: '$patients',
        },
      },
      patients: null,
    },
  },
  {
    $addFields: {
      patients: {
        active: {
          data: '$patientsData.active',
          last: {
            $first: '$patientsData.active',
          },
          count: {
            $size: '$patientsData.active',
          },
        },
        deleted: {
          data: '$patientsData.deleted',
          last: {
            $first: '$patientsData.deleted',
          },
          count: {
            $size: '$patientsData.deleted',
          },
        },
        archived: {
          data: '$patientsData.archived',
          last: {
            $first: '$patientsData.archived',
          },
          count: {
            $size: '$patientsData.archived',
          },
        },
        connected: {
          data: '$patientsData.connected',
          last: {
            $first: '$patientsData.connected',
          },
          count: {
            $size: '$patientsData.connected',
          },
        },
        disconnected: {
          data: '$patientsData.disconnected',
          last: {
            $first: '$patientsData.disconnected',
          },
          count: {
            $size: '$patientsData.disconnected',
          },
        },
        last: '$patientsData.last',
        total: '$patientsData.total',
      },
      patientsData: null,
    },
  },
  {
    $project: {
      patientsData: 0,
      publicKey: 0,
      privateKey: 0,
      sessionNotes_deleted: 0,
      'patients.active.data': 0,
      'patients.deleted.data': 0,
      'patients.archived.data': 0,
      'patients.connected.data': 0,
      'patients.disconnected.data': 0,
    },
  },
];
